exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".high-risk[data-v-64c30e42] {\n  border: 0.2em solid #b71c1c;\n}", ""]);

// exports
